import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './section.css';

const Section = forwardRef(({ 
  className = '', 
  fullWidth = false, 
  children, 
  align = null, 
  gradient = '', 
  ...props 
}, ref) => {
  const fullWidthClass = fullWidth ? 'section--full-width' : '';
  const alignClass = align ? `section--align-${align}` : '';
  const gradientClass = gradient ? `section--gradient-${gradient}` : '';

  return (
    <section ref={ref} className={`section ${fullWidthClass} ${alignClass} ${gradientClass} ${className}`.trim()} {...props}>
      {children}
    </section>
  );
});

Section.propTypes = {
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  align: PropTypes.oneOf([null, 'left', 'center', 'right']),
  gradient: PropTypes.string,
};

export default Section;
